import React from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import env from 'environment';

function OutlinedDatePicker(props) {
    return (
        <LocalizationProvider dateAdapter={AdapterLuxon}>
            <DatePicker
                variant="dialog"
                inputVariant="outlined"
                autoComplete="off"
                format={env.shortDateFormat}
                clearable
                placeholder={env.shortDateFormatPlaceholder}
                allowKeyboardControl
                animateYearScrolling={false}
                fullWidth
                {...props}
            />
        </LocalizationProvider>
    );
}

export default OutlinedDatePicker;